(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1213],{

/***/ 61213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Video_Video; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(41926);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/Video/assets/Cover@2x.png
var Cover_2x = __webpack_require__(32747);
var Cover_2x_default = /*#__PURE__*/__webpack_require__.n(Cover_2x);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/Video/assets/Cover.webp
var Cover = __webpack_require__(71251);
var Cover_default = /*#__PURE__*/__webpack_require__.n(Cover);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/Video/assets/Cover@2x.webp
var assets_Cover_2x = __webpack_require__(17807);
var assets_Cover_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Cover_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/Video/CoverImage.tsx








var CoverImage = function CoverImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* Cover */.Y9, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((Cover_default()), ", ").concat((assets_Cover_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: 750,
        height: 426,
        src: (Cover_2x_default()),
        alt: ""
      })]
    })
  });
};

/* harmony default export */ var Video_CoverImage = (CoverImage);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/Video/Video.tsx







var Video = function Video() {
  var _useState = (0,react.useState)(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  var play = function play() {
    return setPlaying(true);
  };

  var stop = function stop() {
    return setPlaying(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoPlayer/* default */.ZP, {
      url: "https://www.youtube.com/watch?v=nhaKSvfpxIY",
      playing: playing,
      onPause: function onPause() {
        stop();
      },
      onPlay: function onPlay() {
        play();
      },
      children: [!playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* BigPlayButton */.sT, {
        onClick: play
      }, "play-btn"), !playing && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video_CoverImage, {}, "cover")]
    })
  });
};

/* harmony default export */ var Video_Video = (Video);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e13a4cas0"
} : 0)("max-width:800px;padding:40px 25px 0;margin:auto;box-shadow:0px 97px 60px -75px ", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.brand.darkAcai[300];
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:80px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/Video/index.ts


/***/ }),

/***/ 32747:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover@2x-b8cf0bdac46dda031addcbe65610610d.png";

/***/ }),

/***/ 71251:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover-1cbc63bbceda56b4915f175e5955daca.webp";

/***/ }),

/***/ 17807:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover@2x-20bfcc8e7a399a890e1bdb83ff318b6d.webp";

/***/ })

}]);